import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '@awread/global/environments';
import { CurrentUserFacade } from '@awread/core/users';
import { UniversalService } from '@awread/kernel/services';
import { of } from 'rxjs';
import { filter, map, take, timeout, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AdminGuard {
  constructor(
    private router: Router,
    private universalService: UniversalService,
    private currentUserFacade: CurrentUserFacade,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // NOTE: check email ở client chỉ để ẩn/hiện UI, không phải bảo mật.
    // Mọi endpoint admin đều tự verify lại ở server.
    if (this.universalService.isBrowser()) {
      if (!localStorage.getItem('accessToken')) {
        this.router.navigate(['/']);
        return of(false);
      }
      // Akita không persist (persistState đang tắt) nên khi F5 thẳng vào /admin,
      // store còn rỗng cho tới khi mutation thisUser trả về. Phải chờ user load xong,
      // nếu đọc getValue() ngay sẽ luôn rỗng và đá admin về trang chủ.
      return this.currentUserFacade.currentUser$.pipe(
        filter((user: any) => !!user?.userId),
        take(1),
        timeout(10000),
        map((user: any) => {
          if (user.email && environment.adminEmails.includes(user.email)) {
            return true;
          }
          this.router.navigate(['/']);
          return false;
        }),
        catchError(() => {
          this.router.navigate(['/']);
          return of(false);
        }),
      );
    } else {
      return of(true);
    }
  }
}
